import { useState, useEffect, useCallback } from 'react';
import api from '../utils/Api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function usePushNotifications() {
  const [isSupported, setIsSupported] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );

  useEffect(() => {
    setIsSupported('serviceWorker' in navigator && 'PushManager' in window);
  }, []);

  const subscribe = useCallback(async () => {
    if (!('serviceWorker' in navigator && 'PushManager' in window)) return;

    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      await navigator.serviceWorker.ready;

      const granted = await Notification.requestPermission();
      setPermission(granted);
      if (granted !== 'granted') return;

      const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
      const applicationServerKey = urlBase64ToUint8Array(vapidKey);

      let sub = await registration.pushManager.getSubscription();
      if (!sub) {
        sub = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey,
        });
      }

      await api.post('/push-subscription', { subscription: sub.toJSON() });
      setIsSubscribed(true);
    } catch (err) {
      console.error('[usePushNotifications] Error al suscribirse:', err);
    }
  }, []);

  return { isSupported, isSubscribed, permission, subscribe };
}
